const APP_LOCALES = {
    VI: 'vi',
    EN: 'en',
} as const

const APP_STORE = {
    APP: 'app',
    AUTH: 'auth'
}

const APP_AXIOS_CONFIG = {
    TIMEOUT: 60000,
} as const


const APP_THEME = {
    LIGHT: 'light',
    DARK: 'dark',
} as const

const APP_LOCAL_STORAGE_KEY = {
    TOKEN_KEY: 'access_token',
    REFRESH_TOKEN_KEY: 'refresh_token',
    USER_KEY: 'user',
} as const

const APP_SECURE = {
    HEADER_TOKEN_FIX: 'Bearer'
} as const

const APP_HTTP = {
    CONTENT_TYPE: 'Content-Type',

    TYPES: {
        JSON: 'application/json',
        FORM: 'application/x-www-form-urlencoded',
        MULTIPART: 'multipart/form-data',
        TEXT: 'text/plain',
        HTML: 'text/html',
        XML: 'application/xml',
        PDF: 'application/pdf',
        OCTET_STREAM: 'application/octet-stream',
        CSV: 'text/csv',
        ZIP: 'application/zip',
        IMAGE_JPEG: 'image/jpeg',
        IMAGE_PNG: 'image/png',
        IMAGE_WEBP: 'image/webp',
    },

    ACCEPT: {
        JSON: 'application/json',
        ALL: '*/*',
    }
} as const

export {
    APP_LOCALES,
    APP_AXIOS_CONFIG,
    APP_THEME,
    APP_LOCAL_STORAGE_KEY,
    APP_SECURE,
    APP_HTTP,
    APP_STORE
}